module.exports = __webpack_public_path__ + "img/inventory.4829d3a1.svg";